import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCommonConfig } from "../../../../redux/actions";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import ConfirmDataBetDeskonPopup from "../../../Popups/ConfirmDataBetDeskonPopup";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import {
  makeAjax,
  showMessage,
  respStatus,
  url,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../helpers/global_helper";
import BetFiftyFiftySuccessPopup from "../../../Popups/BetFiftyFiftySuccessPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";
import CommonBetHeader from "../CommonBetHeader"
import OddEvenComponent from "./OddEvenComponent";
import BigSmallComponent from "./BigSmallComponent";
import { mobileTotalBetCalculate } from "../FourD/FourDThreeDTwoD/MobileTotalBetCalcy";

const FiftyFifty = (props) => {
  const dispatch = useDispatch();
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const [rowsToShow, setRowsToShow] = useState(4);
  const [betValue, setBetValue] = useState({});
  const [betPopupValue, setBetPopupValue] = useState({});
  const [beli, setBeli] = useState({});
  const [angka, setAngka] = useState([]);
  const [respData, setRespData] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showCancelledPopup, setShowCancelledPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showConfirmationDataPopup, setShowConfirmationDataPopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [gameNames, setGameNames] = useState([]);
  const [gameValues, setGameValues] = useState([]);
  const [enabledRowsOddEven, setEnabledRowsOddEven] = useState([]);
  const [enabledRowsBigSmall, setEnabledRowsBigSmall] = useState([]);
  const [succMessage, setSuccessMessage] = useState("");
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [totalBetAmount, setTotalBetAmount] = useState([]);
  const [bbPayAmount, setBBPayAmount] = useState(0);
  const [defaultValue, setDefaultValue] = useState("");

  // CR-8 changes ================================

  const [activeBetType, setActiveBetType] = useState("oddEven");
  const handleTabClick = (value) => {
    resetAllData();
    setActiveBetType(value);
  };

  // =============================================

  const [reqData, setReqData] = useState({
    gameId: gameId,
    gameType: "5050",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: [],
  });

  useEffect(() => {
    if (Object.keys(betDiscount).length <= 0) {
      setErrorMessage("Togel Data API missing, Refresh page and try again.");
      setShowErrorPopup(true);
      return;
    }
  }, [betDiscount]);

  const handleCheckInput = (e, rowIndex, type) => {
    const { name, value } = e.target;
    let newGameNames = [...gameNames];
    let newGameValues = [...gameValues];
    let keySuffix;

    if (device === "Desktop") {
      setBetValue({
        ...betValue,
        [e.target.name]: value,
      });

      if (type === "OddEven" && !enabledRowsOddEven.includes(rowIndex)) {
        setEnabledRowsOddEven([...enabledRowsOddEven, rowIndex]);
      } else if (
        type === "BigSmall" &&
        !enabledRowsBigSmall.includes(rowIndex)
      ) {
        setEnabledRowsBigSmall([...enabledRowsBigSmall, rowIndex]);
      }
    } else {
      // if (type === "first") {
      //   newGameNames[rowIndex] = value;
      //   if (
      //     newGameValues[rowIndex] === "ganjil" ||
      //     newGameValues[rowIndex] === "genap"
      //   ) {
      //     keySuffix = "OddEven";
      //   } else if (
      //     newGameValues[rowIndex] === "besar" ||
      //     newGameValues[rowIndex] === "kecil"
      //   ) {
      //     keySuffix = "BigSmall";
      //   }
      //   setGameNames(newGameNames);
      // } else if (type === "second") {
      //   if (value === "ganjil" || value === "genap") {
      //     newGameValues[rowIndex] = value;
      //     keySuffix = "OddEven";
      //   } else if (value === "besar" || value === "kecil") {
      //     newGameValues[rowIndex] = value;
      //     keySuffix = "BigSmall";
      //   }
      //   setGameValues(newGameValues);
      // }
      // if (newGameNames[rowIndex] && newGameValues[rowIndex]) {
      //   const key = `${newGameNames[rowIndex]}${keySuffix}${rowIndex}`;
      //   const gameName_gameValue = `${newGameNames[rowIndex]}_${newGameValues[rowIndex]}`;

      //   setBetValue((prevBetValue) => {
      //     const newBetValue = { ...prevBetValue };
      //     // Remove any existing key for the current rowIndex
      //     Object.keys(newBetValue).forEach((k) => {
      //       if (k.endsWith(rowIndex)) {
      //         delete newBetValue[k];
      //       }
      //     });
      //     newBetValue[key] = gameName_gameValue;
      //     return newBetValue;
      //   });
      // }
    }
  };

  const handleDeafultInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultValue(value);
    }
  };

  const handleDeafultInputBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultValue(value);
    }
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCancelledPopup(true);
  };

  const handleInputFocus = (e, rowIndex, columnName) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    const intValue = parseInt(value);
    if (defaultValue !== undefined && defaultValue !== '') {
      const explodeVal = name.split('_')
      const betName = explodeVal[0] + explodeVal[1]

      let betValues = ''
      if (activeBetType == 'oddEven') {
        betValues = explodeVal[1] == 'odd' ? explodeVal[0] + '_ganjil' : explodeVal[0] + '_genap'
      }
      else {
        betValues = explodeVal[1] == 'big' ? explodeVal[0] + '_besar' : explodeVal[0] + '_kecil'
      }
      // setBeli(prevBeli => ({
      //   ...prevBeli,
      //   [betValues]: defaultValue
      // }));
      setBeli(prevBeli => ({
        ...prevBeli,
        [betValues]: defaultValue
      }));

      setBetValue({
        ...betValue,
        [betName]: betValues
      })

      // let newTotalBetAmount = 0;
      // const valBelli = Object.entries(beli).filter(
      //   ([key, value]) => value !== undefined && value !== ""
      // );
      // if (valBelli.length > 0) {
      //   newTotalBetAmount = totalBetAmount;
      // }
      // else {
      //   newTotalBetAmount = 0;
      // }

      // newTotalBetAmount = mobileTotalBetCalculate("5050", betValues, defaultValue, rowIndex, betDiscount, false)
      let newTotalBetAmount = mobileTotalBetCalculate("5050", betValues, defaultValue, rowIndex, betDiscount, false);

      // setTotalBetAmount(prevTotalBetAmount => {
      //   const updatedTotalBetAmount = [...prevTotalBetAmount];
      //   updatedTotalBetAmount[rowIndex + columnName] = newTotalBetAmount;
      //   return updatedTotalBetAmount;
      // });
      setTotalBetAmount(prevTotalBetAmount => {
        const updatedTotalBetAmount = [...prevTotalBetAmount];
        updatedTotalBetAmount[rowIndex + columnName] = newTotalBetAmount;
        return updatedTotalBetAmount;
      });

    }
  }

  const handleInputBlur = (e, rowIndex, columnName) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange(e, rowIndex, columnName);
  }
  const handleInputChange = (e, rowIndex, columnName) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    const intValue = parseInt(value);
    let minValue = null;
    let maxValue = null;
    minValue = betDiscount.showMin / 1000;
    maxValue = betDiscount.showMax / 1000;

    // if (intValue < minValue) {
    //   localStorage.getItem("I18N_LANGUAGE") == "en"
    //     ? setErrorMessage(`Minimal bet ${minValue + "D"} is 1`)
    //     : setErrorMessage(`Minimal taruhan ${minValue + "D"} adalah 1`);
    //   setShowErrorPopup(true);
    //   return;
    // } else 
    if (intValue > maxValue) {
      setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
      setShowErrorPopup(true);
      return;
    }

    // if (device === "Desktop") {
    //   if (/^\d*([.,]\d?)?$/.test(value)) {
    //     setBeli({
    //       ...beli,
    //       [name]: value,
    //     });
    //   }
    // } else {
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (regex.test(value)) {
      const explodeVal = name.split('_')
      const betName = explodeVal[0] + explodeVal[1]

      let betValues = ''
      if (activeBetType == 'oddEven') {
        betValues = explodeVal[1] == 'odd' ? explodeVal[0] + '_ganjil' : explodeVal[0] + '_genap'
      }
      else {
        betValues = explodeVal[0] + `${explodeVal[1] == 'big' ? '_besar' : '_kecil'}`
      }
      // setBeli(prevBeli => ({
      //   ...prevBeli,
      //   [betValues]: value
      // }));

      setBeli(prevBeli => ({
        ...prevBeli,
        [betValues]: value
      }));

      setBetValue({
        ...betValue,
        [betName]: betValues
      })

      // let newTotalBetAmount = 0;
      // const valBelli = Object.entries(beli).filter(
      //   ([key, value]) => value !== undefined && value !== ""
      // );
      // if (valBelli.length > 0) {
      //   newTotalBetAmount = totalBetAmount;
      // }
      // else {
      //   newTotalBetAmount = 0;
      // }

      // newTotalBetAmount = mobileTotalBetCalculate("5050", betValues, value, rowIndex, betDiscount, false)
      let newTotalBetAmount = mobileTotalBetCalculate("5050", betValues, value, rowIndex, betDiscount, false);
      // setTotalBetAmount(prevTotalBetAmount => {
      //   const updatedTotalBetAmount = [...prevTotalBetAmount];
      //   updatedTotalBetAmount[rowIndex + columnName] = newTotalBetAmount;
      //   return updatedTotalBetAmount;
      // });
      setTotalBetAmount(prevTotalBetAmount => {
        const updatedTotalBetAmount = [...prevTotalBetAmount];
        updatedTotalBetAmount[rowIndex + columnName] = newTotalBetAmount;
        return updatedTotalBetAmount;
      });
    }
    // }
  };
  const submitForm = () => {
    let angka = [];
    const betAmount = Object.values(beli).reduce((total, itme) => total + parseInt(itme), 0);
    const totalAmount = betAmount * betDiscount.showMultiple
    if (totalAmount > user_balance.coin) {
      setErrorMessage(props.t("insufficient_balance"));
      setShowErrorPopup(true);
    } else {
      if (Object.keys(betValue).length > 0) {
        if (Object.keys(betValue).length == Object.values(beli).filter(item => item !== '').length) {
          // if (device == "Desktop") {
          //   Object.entries(betValue).filter((item, key) => {
          //     const newBet = [item[1], beli[item[0]] * 1000, "success"];
          //     angka.push(newBet);
          //   });
          // }
          // else {
          Object.entries(betValue).filter((item, key) => {
            if (beli[item[1]] != 0) {
              const newBet = [item[1], beli[item[1]] * betDiscount.showMultiple, "success"];
              angka.push(newBet);
            }
          });
          // }
          setAngka(angka);
          setSuccessMessage("");
          setShowConfirmationPopup(true);
        } else {
          if (Object.values(beli).filter(item => item !== '').length > 0) {
            // if (device == "Desktop") {
            //   Object.entries(betValue).filter((item, key) => {
            //     if (beli[item[0]] && beli[item[0]] !== "") {
            //       const newBet = [item[1], beli[item[0]] * 1000, "success"];
            //       angka.push(newBet);
            //     }
            //   });
            // }
            // else {
            Object.entries(betValue).filter((item, key) => {
              if (beli[item[1]] != 0) {
                const newBet = [item[1], beli[item[1]] * betDiscount.showMultiple, "success"];
                angka.push(newBet);
              }
            });
            // }

            setAngka(angka);
            setSuccessMessage("");
            setShowConfirmationPopup(true);
          } else {
            setErrorMessage(props.t("guess_bet_wrong"));
            setShowErrorPopup(true);
          }
        }
      } else {
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
      }
    }
  };

  useEffect(() => {
    setReqData({
      ...reqData,
      dataangka: angka,
    });
  }, [angka]);

  const guessArray = ["AS", "Kop", "Kepala", "Ekor"];
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    makeAjax(url.TOGEL_API.process5050Shio, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          response.code
            ? setErrorMessage(props.t(response.code))
            : setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setBetPopupValue(betValue);
      setShowConfirmationPopup(false);
      setRespData((prevArray) => [...prevArray, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
      resetAllData();
    });
  };

  useEffect(() => {
    resetAllData();
  }, [gameId]);

  const resetAllData = () => {
    setGameValues([]);
    setGameNames([]);
    setAngka([]);
    setBeli({});
    setBetValue({});
    setEnabledRowsOddEven([]);
    setEnabledRowsBigSmall([]);
    setReqData({
      gameId: gameId,
      gameType: "5050",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dataangka: [],
    });
    setDefaultValue(""); // Reset defaultValue
    setTotalBetAmount([]); // Reset totalBetAmount
    setBBPayAmount(0); // Reset bbPayAmount
  };

  useEffect(() => {
    resetAllData();
  }, [gameId]);

  const handlePopupClose = () => {
    setRespData([]);
    setSuccessPopup(false);
  };

  const resetRow = (rowIndex) => {
    let newGameNames = [...gameNames];
    let newGameValues = [...gameValues];
    let newBetValue = { ...betValue };
    let newBeli = { ...beli };

    // Reset the game name and value for the row
    newGameNames[rowIndex] = "";
    newGameValues[rowIndex] = "";

    // Remove the bet value for the row
    Object.keys(newBetValue).forEach((key) => {
      if (key.endsWith(rowIndex)) {
        delete newBetValue[key];
      }
    });

    // Remove the beli value for the row
    Object.keys(newBeli).forEach((key) => {
      if (key.endsWith(rowIndex)) {
        delete newBeli[key];
      }
    });

    setGameNames(newGameNames);
    setGameValues(newGameValues);
    setBetValue(newBetValue);
    setBeli(newBeli);
  };

  return (
    <div className="fiftyfifty_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* {device === "Desktop" ? (
            <>
              <div className="fiftyfifty_heading">
                <h1>
                  {props.t("odd")}/{props.t("even")}
                </h1>
              </div>
              <div className="fiftyfifty_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("position")}</th>
                      <th>{props.t("guess")}</th>
                      <th>{props.t("kei")} (%)</th>
                      <th>
                        {" "}
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow)].map((_, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        <td className="input">{guessArray[index]}</td>
                        <td className="input" valign="middle">
                          <input
                            type="radio"
                            onClick={(e) =>
                              handleCheckInput(e, index, "OddEven")
                            }
                            disabled={false}
                            name={
                              guessArray[index].toLowerCase() +
                              "OddEven" +
                              index
                            }
                            value={guessArray[index].toLowerCase() + "_ganjil"}
                            checked={
                              betValue[
                                guessArray[index].toLowerCase() +
                                "OddEven" +
                                index
                              ] == [guessArray[index].toLowerCase() + "_ganjil"]
                                ? true
                                : false
                            }
                          />
                          &nbsp; {props.t("odd")} &nbsp; &nbsp;
                          <input
                            type="radio"
                            onClick={(e) =>
                              handleCheckInput(e, index, "OddEven")
                            }
                            disabled={false}
                            name={
                              guessArray[index].toLowerCase() +
                              "OddEven" +
                              index
                            }
                            value={guessArray[index].toLowerCase() + "_genap"}
                            checked={
                              betValue[
                                guessArray[index].toLowerCase() +
                                "OddEven" +
                                index
                              ] == [guessArray[index].toLowerCase() + "_genap"]
                                ? true
                                : false
                            }
                          />
                          &nbsp; {props.t("even")}
                        </td>

                        <td>-2.2% | -2.2%</td>
                        <td className="inputs">
                          <input
                            type="text"
                            placeholder="1 = 1000 IDR"
                            name={
                              guessArray[index].toLowerCase() +
                              "OddEven" +
                              index
                            }
                            value={
                              beli[
                                guessArray[index].toLowerCase() +
                                "OddEven" +
                                index
                              ]
                                ? beli[
                                guessArray[index].toLowerCase() +
                                "OddEven" +
                                index
                                ]
                                : ""
                            }
                            disabled={!enabledRowsOddEven.includes(index)}
                            onChange={(e) =>
                              handleInputChange(e, index, "Belli")
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="fiftyfifty_heading" style={{ marginTop: "10px" }}>
                <h1>
                  {props.t("big")}/{props.t("small")}
                </h1>
              </div>
              <div className="fiftyfifty_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("position")}</th>
                      <th>{props.t("guess")}</th>
                      <th>{props.t("kei")} (%)</th>
                      <th>
                        {" "}
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow)].map((_, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        <td className="input">{guessArray[index]}</td>
                        <td className="input" valign="middle">
                          <input
                            type="radio"
                            onClick={(e) =>
                              handleCheckInput(e, index, "BigSmall")
                            }
                            disabled={false}
                            name={
                              guessArray[index].toLowerCase() +
                              "BigSmall" +
                              index
                            }
                            value={guessArray[index].toLowerCase() + "_besar"}
                            checked={
                              betValue[
                                guessArray[index].toLowerCase() +
                                "BigSmall" +
                                index
                              ] == [guessArray[index].toLowerCase() + "_besar"]
                                ? true
                                : false
                            }
                          />
                          &nbsp; {props.t("big")} &nbsp; &nbsp;
                          <input
                            type="radio"
                            onClick={(e) =>
                              handleCheckInput(e, index, "BigSmall")
                            }
                            disabled={false}
                            name={
                              guessArray[index].toLowerCase() +
                              "BigSmall" +
                              index
                            }
                            value={guessArray[index].toLowerCase() + "_kecil"}
                            checked={
                              betValue[
                                guessArray[index].toLowerCase() +
                                "BigSmall" +
                                index
                              ] == [guessArray[index].toLowerCase() + "_kecil"]
                                ? true
                                : false
                            }
                          />
                          &nbsp;{props.t("small")}
                        </td>

                        <td>-2.2% | -2.2%</td>
                        <td className="inputs">
                          <input
                            type="text"
                            placeholder="1 = 1,000 IDR"
                            name={
                              guessArray[index].toLowerCase() +
                              "BigSmall" +
                              index
                            }
                            value={
                              beli[
                                guessArray[index].toLowerCase() +
                                "BigSmall" +
                                index
                              ]
                                ? beli[
                                guessArray[index].toLowerCase() +
                                "BigSmall" +
                                index
                                ]
                                : ""
                            }
                            disabled={!enabledRowsBigSmall.includes(index)}
                            onChange={(e) =>
                              handleInputChange(e, index, "Belli")
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : ( */}
          <div className="container" style={{ flexDirection: "column", maxHeight: "inherit", marginTop: 6 }}>
            {/* {device === "Mobile" && ( */}
            <CommonBetHeader rowsToShow={null} handleRowsToShowChange={null} bbPayAmount={bbPayAmount} totalBetAmount={totalBetAmount} />
            {/* )} */}

            <div className="inner_nav-tabwrapper" >
              <div
                className={`inner_tab ${activeBetType === "oddEven" ? "active" : ""}`}
                onClick={() => handleTabClick("oddEven")}
              >
                {props.t("odd").toUpperCase()} / {props.t("even").toUpperCase()}
              </div>
              <div
                className={`inner_tab ${activeBetType === "bigSmall" ? "active" : ""}`}
                onClick={() => handleTabClick("bigSmall")}
              >
                {(props.t("big")).toUpperCase()} / {(props.t("small")).toUpperCase()}
              </div>
            </div>
            <div className="tabcontent-wrapper" style={{ marginTop: 0 }}>
              {activeBetType == 'oddEven' && (<OddEvenComponent handleDeafultInputChange={handleDeafultInputChange} handleDeafultInputBlur={handleDeafultInputBlur} defaultValue={defaultValue} betDiscount={betDiscount} handleInputChange={handleInputChange} handleInputBlur={handleInputBlur} gameNames={gameNames} betValue={betValue} beli={beli} handleInputFocus={handleInputFocus} />)}
              {activeBetType == 'bigSmall' && (<BigSmallComponent handleDeafultInputChange={handleDeafultInputChange} handleDeafultInputBlur={handleDeafultInputBlur} defaultValue={defaultValue} betDiscount={betDiscount} handleInputChange={handleInputChange} handleInputBlur={handleInputBlur} gameNames={gameNames} betValue={betValue} beli={beli} handleInputFocus={handleInputFocus} />)}
            </div>
            {/* <table>
                <thead>
                  <tr>
                    <th>{props.t("no.")}</th>
                    <th>{props.t("position")}</th>
                    <th>{props.t("guess")}</th>
                    <th>{props.t("kei")}</th>
                    <th>
                      {props.t("buy")}
                      <span className="small_input">1=1000</span>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((_, index) => (
                    <tr key={index} className={`row-${index}`}>
                      <td>{index + 1}</td>
                      <td className="inputs">
                        <select
                          value={gameNames[index] || ""}
                          onChange={(e) => handleCheckInput(e, index, "first")}
                        >
                          <option value=""></option>
                          <option value="as">as</option>
                          <option value="kop">kop</option>
                          <option value="kepala">kepala</option>
                          <option value="ekor">ekor</option>
                        </select>
                      </td>
                      <td className="inputs">
                        <select
                          value={gameValues[index] || ""}
                          onChange={(e) => handleCheckInput(e, index, "second")}
                        >
                          <option value=""></option>
                          <option value="ganjil">{props.t("odd")}</option>
                          <option value="genap">{props.t("even")}</option>
                          <option value="besar">{props.t("big")}</option>
                          <option value="kecil">{props.t("small")}</option>
                        </select>
                      </td>

                      <td>
                        <input
                          type="text"
                          // value={betDiscount.kei_as_besar + '%'}
                          value={
                            betDiscount.kei_as_besar
                              ? betDiscount.kei_as_besar + "%"
                              : ""
                          }
                          readOnly
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="1 = 1,000 IDR"
                          name={
                            gameValues[index] === "ganjil" ||
                              gameValues[index] === "genap"
                              ? `${gameNames[index]}OddEven${index}`
                              : `${gameNames[index]}BigSmall${index}`
                          }
                          value={
                            gameValues[index] === "ganjil" ||
                              gameValues[index] === "genap"
                              ? beli[`${gameNames[index]}OddEven${index}`] || ""
                              : beli[`${gameNames[index]}BigSmall${index}`] ||
                              ""
                          }
                          onChange={(e) => handleInputChange(e, index, "Belli")}
                          inputMode="numeric"
                          pattern="[0-9]*"
                        />
                      </td>
                      <td>
                        <button
                          onClick={() => resetRow(index)}
                          className="reset-button"
                        >
                          Reset
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table> */}
          </div>
          {/* )} */}

          <div className="last_div">
            <div className="left_div">
              <p>{props.t("5050_text")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button onClick={resetAllData} className="reset">
                    Reset
                  </button>
                </li>
                <li>
                  <button onClick={submitForm} className="submit">
                    {props.t("submit")}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          message={succMessage}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCancelledPopup(false)} />
      )}
      {showConfirmationDataPopup && (
        <ConfirmDataBetDeskonPopup
          onClose={() => setShowConfirmationDataPopup(false)}
          submitProcessOk={submitProcessOk}
        />
      )}
      {successPopup && (
        <div className="popup-overlay ">
          <BetFiftyFiftySuccessPopup
            response={respData}
            betValue={betPopupValue}
            onClose={handlePopupClose}
          />
        </div>
      )}
      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }
    </div>
  );
};

export default withTranslation()(FiftyFifty);
